import moment from 'utils/cops-moment';
import { laneConfig } from '../config';
import roundNearest from './round-nearest';

export const calculateSnap = (widthDay, hoursCount) => {
  const widthHour = widthDay / hoursCount;
  let snapToMinutes = 60;
  if (widthHour > laneConfig.smallestSnapWidth * 2) {
    snapToMinutes = 15;
  } else if (
    widthHour < laneConfig.smallestSnapWidth * 2 &&
    widthHour > laneConfig.smallestSnapWidth
  ) {
    snapToMinutes = 30;
  }
  return snapToMinutes;
};

export const getDateToString = (date, view) => {
  // day month --> should start from a specific date
  let dateToShow = moment()
    .year(date.year)
    .month(date.month)
    .date(date.day);

  // week --> should start from the starting of the week
  if (view?.calendarType === 'week') {
    dateToShow = dateToShow.startOf('week');
  }
  if (view?.calendarType === 'month') {
    dateToShow = dateToShow.startOf('month');
  }
  return dateToShow.format('YYYYMMDD');
};

// converts a decimal to time: 1.25 => { hour: 1, minute: 15}
export const decimalToTime = (decimal, doSnap = false, snapToMinutes = 30) => {
  let hour = Math.floor(Math.abs(decimal));
  let minute = Math.floor((Math.abs(decimal) * 60) % 60);

  // if snapping is enabled, dropped minute should snap to the config
  if (doSnap) {
    const nearestMinute = roundNearest(minute, snapToMinutes);
    minute = nearestMinute;
    if (nearestMinute === 60) {
      hour += 1;
      minute = 0;
    }
  }

  hour = String(hour).padStart(2, '0');
  minute = String(minute).padStart(2, '0');

  return {
    hour,
    minute,
  };
};
